export default __webpack_public_path__ + "static/media/mobisis-logo-vector.dd4e8265.svg";